'use client';

import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useMotionValue, type MotionValue } from 'framer-motion';

interface MousePositionContextValue {
	x: MotionValue<number>;
	y: MotionValue<number>;
}

const MousePositionContext = createContext<MousePositionContextValue | null>(
	null,
);

export const MousePositionProvider = ({ children }: { children: ReactNode }) => {
	const x = useMotionValue(0);
	const y = useMotionValue(0);

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			x.set(e.clientX);
			y.set(e.clientY);
		};
		window.addEventListener('mousemove', handler);
		return () => window.removeEventListener('mousemove', handler);
	}, [x, y]);

	return (
		<MousePositionContext.Provider value={{ x, y }}>
			{children}
		</MousePositionContext.Provider>
	);
};

export const useMousePosition = () => {
	const ctx = useContext(MousePositionContext);
	if (!ctx)
		throw new Error(
			'useMousePosition must be used within a MousePositionProvider',
		);
	return ctx;
};
